import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AlertMessageService, LoadingService } from '@serpro/ngx-suite-rfb';
import { AtoService } from 'src/app/shared/services/ato.service';
import { StringUtil } from 'src/app/shared/util/string.util';

@Component({
	selector: 'app-comparar-atos',
	templateUrl: './comparar-atos.component.html',
	styleUrls: ['./comparar-atos.component.css']
})
export class CompararAtosComponent implements OnInit {

	@Input() conteudoAto: string;
	@Input() idAtoBase: number;
	@Input() idAtoCorrecao: number;

	@Output() fechar: EventEmitter<number> = new EventEmitter<number>();
	@Output() fecharEProsseguir: EventEmitter<number> = new EventEmitter<number>();
	@Output() fecharERepublicar: EventEmitter<number> = new EventEmitter<number>();
	@Output() fecharEConverterPublicacaoRepetida: EventEmitter<number> = new EventEmitter<number>();

	@ViewChild('btnFecharModalComparacao', { static: false }) btnFecharModalComparacao!: ElementRef;
	
	conteudoAtoBase: string;
	exibirComparacao = false;
	naoPermiteRepublicacao = true;

	constructor(
		private atoService: AtoService,
		private alertMessageService: AlertMessageService,
		private loadingService: LoadingService
	) { }

	ngOnInit(): void {

		this.loadingService.show();

		if (this.idAtoCorrecao && this.idAtoCorrecao !== 0) {
			this.atoService.obterConteudoParaComparacaoPorId(this.idAtoCorrecao).subscribe({
				next: retorno => {
					this.loadingService.hide();
					if (!retorno.conteudo || retorno.conteudo.length == 0) {
						this.alertMessageService.warn('Alerta', 'Não foi possível obter o conteúdo do ato ' + this.idAtoBase + ' para comparação.');
					} else {
						this.conteudoAto = StringUtil.removerLinhasVazias(retorno.conteudo);
						this.exibirComparacao = true;
					}
				},
				error: (e) => {
					this.fecharModal();
					this.alertMessageService.dismissAll();

					if (e?.error?.message?.indexOf('A visão solicitada não está disponível para este ato. Consulte a visão ') == 0) {
						this.alertMessageService.warn('Alerta', 'Não foi possível obter o conteúdo da visão vigente do ato ' + this.idAtoBase + ' para comparação.');

						setTimeout(() => {
							this.loadingService.hide();
						}, 20);
					} else {
						this.loadingService.hide();
					}
				}
			});
		} else {
			this.conteudoAto = StringUtil.removerTagsHtml(StringUtil.removerLinhasVazias(this.conteudoAto));
			this.exibirComparacao = true;
		}

        this.atoService.obterConteudoParaComparacaoPorId(this.idAtoBase).subscribe({
            next: retorno => {
				this.loadingService.hide();
                if (!retorno.conteudo || retorno.conteudo.length == 0) {
                    this.alertMessageService.warn('Alerta', 'Não foi possível obter o conteúdo do ato ' + this.idAtoBase + ' para comparação.');
                } else {
					this.conteudoAtoBase = StringUtil.removerLinhasVazias(retorno.conteudo);
					this.naoPermiteRepublicacao = retorno.republicacao;
				}
				this.focarNoBotaoFechar();
            },
            error: (e) => {
				this.fecharModal();				
				this.alertMessageService.dismissAll();

				if (e?.error?.message?.indexOf('A visão solicitada não está disponível para este ato. Consulte a visão ') == 0) {
                    this.alertMessageService.warn('Alerta', 'Não foi possível obter o conteúdo da visão vigente do ato ' + this.idAtoBase + ' para comparação.');

					setTimeout(() => {
                        this.loadingService.hide();
                    }, 20);
                } else {
                    this.loadingService.hide();
                }   
			}
        });
	}

	focarNoBotaoFechar() {
		setTimeout(() => {
			if (this.btnFecharModalComparacao) {
				this.btnFecharModalComparacao.nativeElement?.focus();
			} else {
				console.error('O botão não foi encontrado.');
			}
		}, 100);
	}

	public fecharModal() {
		this.fechar.emit(0);
    }

	public fecharModalERepublicar() {
		this.fecharERepublicar.emit(this.idAtoBase);
    }

	public fecharModalEConverterPubRepetida() {
		this.fecharEConverterPublicacaoRepetida.emit(this.idAtoBase);
    }

	public fecharModalEIncluirAssimMesmo() {
		this.fecharEProsseguir.emit(0);
	}
}